import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe70bbdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero is-fullheight p-6" }
const _hoisted_2 = { class: "container has-background-light is-flex is-flex-direction-column is-justify-content-center is-align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/eJtCOKK.jpeg",
    class: "image logo-image",
    alt: "logo"
  })
], -1))
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "control has-icons-left has-icons-right" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "control has-icons-left" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "control has-text-centered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"])),
        class: "p-3"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "email",
              placeholder: "Email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.email]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "password",
              placeholder: "Password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-success is-fullwidth", {'is-loading':_ctx.isChecking}])
            }, " Login ", 2)
          ])
        ])
      ], 32)
    ])
  ]))
}